import { format, formatDistanceToNowStrict, isValid, parseISO } from "date-fns";
import { de } from "date-fns/locale";

/** The whole application works in Austrian local time and German formats. */
export function dateTime(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = parseISO(iso);
  return isValid(d) ? format(d, "dd.MM.yyyy HH:mm", { locale: de }) : "—";
}

export function dateOnly(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = parseISO(iso);
  return isValid(d) ? format(d, "dd.MM.yyyy", { locale: de }) : "—";
}

export function relative(iso: string | null | undefined): string {
  if (!iso) return "—";
  const d = parseISO(iso);
  if (!isValid(d)) return "—";
  return formatDistanceToNowStrict(d, { locale: de, addSuffix: true });
}

/** An absence without an end runs until somebody ends it. */
export function endLabel(iso: string | null | undefined): string {
  return iso ? dateTime(iso) : "bis auf Weiteres";
}

export function initials(first: string, last: string): string {
  return `${first.charAt(0)}${last.charAt(0)}`.toUpperCase() || "?";
}
